

export default function InfoComponent({info}) {
    return (
        <div className="row">
                <div className="col">
                    <blockquote className="with-borders bg-info-geo shadow">
                        <p className="text-light text-4 line-height-2 m-0">
                            <i className="icon-info pr-2"></i>
                           {info}
                        </p>
                    </blockquote>
                </div>
        </div>
    )
}
